import { call, put, select } from "redux-saga/effects";
import AuthenticationActions, {
  AuthenticationSelectors
} from "Redux/AuthenticationRedux";
import ProfileActions from "Redux/ProfileRedux";
import { refreshToken } from "Sagas/AuthSagas/workers";
import { isTokenExpired } from "Utils/Interceptor";

const camelcaseKeys = require("camelcase-keys");
const decamelizeKeys = require("decamelize-keys");

// --- This gets the profile of the user --- //
export function* profile(api, { resolve }) {
  const token = yield select(AuthenticationSelectors.getAccessToken);
  const response = yield call(api.profile, token);
  const camelizedData = camelcaseKeys(response.data, { deep: true });
  if (response.status === 200 || response.status === 201) {
    yield put(ProfileActions.profileSuccess(camelizedData));
  } else {
    if (isTokenExpired(response.data)) {
      yield call(refreshToken, ProfileActions.profileRequest(resolve));
    } else {
      yield put(ProfileActions.profileFailure(response.data));
    }
  }
}

// --- This gets the public profile of whichever profile the user is viewing --- //
export function* publicProfileSaga(api, { data, resolve }) {
  const response = yield call(api.publicProfileApi, data);
  const camelizedData = camelcaseKeys(response.data, { deep: true });
  if (response.status === 200 || response.status === 201) {
    yield put(ProfileActions.publicProfileSuccess(camelizedData));
    yield call(resolve.onSuccess);
  } else {
    yield put(ProfileActions.publicProfileFailure(response.data));
    resolve.onFailure(response.data);
    yield call(resolve.onFailure, response.data)
  }
}

// --- This updates the user's avatar --- //
export function* updateAvatarRequestSaga(api, { data }) {
  const token = yield select(AuthenticationSelectors.getAccessToken);
  const response = yield call(api.updateAvatarApi, { token, data });
  const camelizedData = camelcaseKeys(response.data, { deep: true });
  if (response.status === 200 || response.status === 201) {
    // yield put(ProfileActions.updateAvatarSuccess(camelizedData));
    yield put(AuthenticationActions.updateUserDetailsSuccess(camelizedData));
  } else {
    if (isTokenExpired(response.data)) {
      yield call(refreshToken, ProfileActions.updateAvatarRequest(data));
    } else {
      yield put(ProfileActions.updateAvatarFailure(response.data));
    }
  }
}

// --- This updates the profile (e.g. Settings) --- //
export function* profileUpdate(api, { data, resolve }) {
  const token = yield select(AuthenticationSelectors.getAccessToken);
  const response = yield call(api.profileUpdate, {
    token,
    data: decamelizeKeys(data)
  });
  if (response.status === 200 || response.status === 201) {
    yield put(ProfileActions.profileUpdateSuccess(response.data));
    yield put(AuthenticationActions.profileUpdateSuccess(response.data));
    resolve.onSuccess();
  } else {
    if (isTokenExpired(response.data)) {
      yield call(refreshToken, () =>
        ProfileActions.profileUpdateSuccess(data, resolve)
      );
    } else {
      yield put(ProfileActions.profileUpdateFailure(response.data));
      yield call(resolve.onFailure, response.data);
    }
  }
}

// --- This gets the user's profile links --- //
export function* getProfileLinksSaga(api, { data }) {
  const response = yield call(api.getProfileLinksApi, data);
  const camelizedData = camelcaseKeys(response.data, { deep: true });
  if (response.status === 200 || response.status === 201) {
    yield put(ProfileActions.getProfileLinksSuccess(camelizedData));
  } else {
    yield put(ProfileActions.getProfileLinksFailure(camelizedData));
    // if (isTokenExpired(response.data)) {
    //   yield call(refreshToken, ProfileActions.getProfileLinksRequest(data));
    // } else {
    // }
  }
}

// --- This updates the user's profile links --- //
export function* updateProfileLinksSaga(api, { data, resolve }) {
  const token = yield select(AuthenticationSelectors.getAccessToken);
  const response = yield call(api.updateProfileLinksApi, {
    token,
    data: decamelizeKeys(data)
  });
  const camelizedData = camelcaseKeys(response.data, { deep: true });
  if (response.status === 200 || response.status === 201) {
    yield put(ProfileActions.updateProfileLinksSuccess(camelizedData));
    resolve.onSuccess();
  } else {
    if (isTokenExpired(response.data)) {
      yield call(
        refreshToken,
        ProfileActions.updateProfileLinksRequest(data, resolve)
      );
    } else {
      yield put(ProfileActions.updateProfileLinksFailure(camelizedData));
      yield call(resolve.onFailure, response.data);
    }
  }
}

// --- This creates the user profile (may be deprecated) --- //
export function* createProfile(api, action) {
  const response = yield call(api.createProfile, action.data);
  if (response.status === 200 || response.status === 201) {
    yield put(ProfileActions.createProfileSuccess(response.data));
  } else {
    yield put(ProfileActions.createProfileFailure(response.data));
  }
}

